import * as React from 'react';
import { useHistory } from 'react-router';
import { Button } from '../components/Button';
import { PageHeader } from '../components/PageHeader';
import './NotFoundPage.css';

/**
 * 404 Not Found
 */
export const NotFoundPage: React.FC = function () {
  const history = useHistory();

  return (
    <div className="NotFoundPage">
      <PageHeader title="ページが見つかりません" />
      <p className="NotFoundPage-message">
        お探しのページは見つかりませんでした。（404 Not Found）
      </p>
      <div className="NotFoundPage-actions">
        <Button onClick={() => history.push('/')}>トップへ戻る</Button>
      </div>
    </div>
  );
};
